<template>
    <div>
        <div class="memberInfo-top">
            <div class="memberInfo-top-left">
                <div class="memberInfo-header">
                    <Upload
                            ref="upload"
                            :show-upload-list="false"
                            :on-success="handleSuccess"
                            :on-format-error="handleFormatError"
                            :on-exceeded-size="handleMaxSize"
                            :before-upload="handleBeforeUpload"
                            :multiple="false"
                            accept=".jpg,.jpeg,.png"
                            action=""
                            style="display: inline-block;">
                        <img style="cursor:pointer;border-radius:50%" :src="userRealPhoto+'?x-image-process=image/resize,m_fixed,w_50,h_50'" class="header-img" alt='版权登记'/>
                    </Upload>
                    <!-- <Tooltip :content="nickThankName" placement="bottom">
                        <div v-if="showEditVertial=='N'" class="nickThankName" style="margin:0px 15px;margin-top:10px;">
                            <div class="t">欢迎你!</div>
                            <div>{{nickThankName}}</div>
                        </div>
                    </Tooltip> -->
                    <div  class="nickThankName" style="margin:0px 15px;margin-top:10px;">
                        <div class="t">欢迎你!</div>
                        <div class="nameBox" v-if="showEditVertial=='N'">
                            <div>{{nickThankName}}</div>
                            <img @click="edit()" src="@/assets/bianji.png" class="bianji-img" alt='版权登记'/>
                        </div>
                        <div v-if="showEditVertial=='Y'" class="editbutton">
                            <input class="showedit" maxlength="20" type="text" v-model="nickThankName"/>
                            <input class="showbutton" @click="editSave()" style="margin-left:10px;margin-right:10px;" type="button" value="保存"/>
                            <input class="showbuttonQ" @click="editCancel()" style="background:#eee" type="button" value="取消"/>
                        </div>
                    </div>


                </div>

            </div>

        </div>

        <div class="memberInfo-center" style="margin-top:25px;">
            <div class="title" style="width:100%">
                <span class="myTitle" style="margin-left:25px;">账号信息</span>
            </div>
            <ul class="memberInfo-link">
                <li>
                    <div class="newItme">
                        <img src="@/assets/shoujihao.png" alt='版权登记'/>
                        <div class="text">
                            <p>手机号</p>
                            <p>{{userInfo.mobilePhone?userInfo.mobilePhone:''}}</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="newItme">
                        <img src="@/assets/youxiang.png" alt='版权登记'/>
                        <div class="text">
                            <p>邮箱</p>
                            <p v-if="userInfo.emailBindStatus=='0'" class="">未绑定<a @click="bangding()">绑定</a></p>
                            <p v-if="userInfo.emailBindStatus=='1'" class="">已绑定</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="newItme">
                        <img src="@/assets/mima.png" alt='版权登记'/>
                        <div class="text">
                            <p>密码</p>
                            <p class="">已设定<a @click="setpassword()">修改</a></p>
                        </div>
                    </div>
                </li>

            </ul>
        </div>
        <generalframe @fatherMethod="fatherMethod" v-show="showDialog" maintitle="绑定邮箱" ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr">
                    <p style="width:58px;">邮箱：</p>
                    <div class="emailRelative">
                        <input v-model="email" style="flex:1" type="text" placeholder="请输入邮箱"/>
                        <div @click="_postLoginSendSmsCode('3')" class="loginVertialsf"
                             :style="{pointerEvents:ver_disabled}">{{verifyCode_time}}
                        </div>
                    </div>
                </div>
                <p class="red-p" v-show="showEmail">请输入正确的邮箱账号</p>
                <div class="ts_content_fr" style="margin-top:30px;">
                    <p style="width:58px;">验证码：</p>
                    <input v-model="typeverifyCode" type="text" placeholder="请输入验证码"/>
                </div>
                <p class="red-p" v-show="showEmailCode">请输入验证码</p>
                <input style="margin-top:30px;" class="goOrderEsc" @click="this.sureOrder" type="button" value="绑定"/>
            </div>
        </generalframe>
        <generalframe @fatherMethod="fatherMethod" v-show="showDialog02" myheight="458" maintitle="修改密码" ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr" style="margin-bottom:15px;justify-content:space-between">
                    <p style="width:270px;">用户名：<span style="opacity:0">用</span> {{accountNum}}</p>
                    <div @click="_getLoginSendSmsCode('5')" class="loginVertial"
                         :style="{pointerEvents:ver_disabled_dx}">{{verifyCode_time_dx}}
                    </div>
                </div>
                <div class="ts_content_fr" :style="{marginBottom:showPhoneCode?'0px':'15px'}">
                    <p style="width:75px">验证码：</p>
                    <input style="width:286px;" v-model="verifyCode" type="text" placeholder="请输入验证码"/>
                </div>
                <p class="red-p" v-show="showPhoneCode" style="margin-left:76px">请输入验证码</p>
                <div class="ts_content_fr" :style="{marginBottom:showOneCode?'0px':'15px'}">
                    <p style="width:75px">新密码：</p>
                    <form>
                        <input style="width:286px;" v-model="password" autocomplete="off" type="password"
                               placeholder="请输入新密码"/>
                    </form>
                </div>
                <p class="red-p" v-show="showOneCode" style="margin-left:76px">请输入正确的密码，必须包含英文字母和数字，8到20位，不允许包含符号</p>
                <div class="ts_content_fr" :style="{marginBottom:showTwoCode?'0px':'30px'}">
                    <p style="width:75px;">确认密码：</p>
                    <form>
                        <input style="width:286px;" v-model="nextPassword" autocomplete="off" type="password"
                               placeholder="请确认密码"/>
                    </form>
                </div>
                <p class="red-p" v-show="showTwoCode" style="margin-left:76px">请确认两次密码一致</p>
                <input class="goOrderEsc" style="margin-top:0px;" @click="surePassword" type="button" value="修改"/>
            </div>
        </generalframe>
        <mycapay @fatherModal="fatherModal" @updateVipData='updateVipData' mywidth='838' myheight="585"
                 myTitleheight="50" v-if="showDialog03"/>
        <!-- 转出 -->
        <generalframe @fatherMethod="fatherMethod07" v-show="showDialog07" maintitle="转出到钱包" ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr">
                    <p>转出金额：</p>
                    <input v-model="money" class="text-input" placeholder="请输入转出金额" type="text"/>
                </div>
                <p class="red-p" v-if="showMoney" style="margin-left:70px">{{moneyTip}}</p>
                <p style="margin-top:35px">转出到钱包后可用于平台消费</p>
                <button class="btn-150" @click="submitMoney">确认转出</button>
            </div>
        </generalframe>
        <!-- 输入邀请码 -->
        <generalframe @fatherMethod="fatherMethodCode" v-show="showDialog01" maintitle="邀请码">
            <div class="ts_content">
                <div class="ts_content_fr">
                    <p style="margin-right:0px">邀请码：</p>
                    <input v-model="inviteNumberCode" class="text-input" placeholder="请输入邀请码" type="text"/>
                </div>
                <p class="red-p" v-if="showInviteNumber" style="margin-left:74px">请输入正确的邀请码</p>
                <button class="btn-150" @click="submitNumber">确认</button>
            </div>
        </generalframe>
        <!-- 提现 -->
        <generalframe @fatherMethod="fatherMethodMoney" v-show="showModal" maintitle="提现到支付宝">
            <div class="ts_contentout">
                <div class="ts_content_frout">
                    <p class="pout">提现金额：</p>
                    <input v-model="outmoney" class="text-inputout" placeholder="请输入提现金额" type="text"/>
                </div>
                <p class="red-pout" v-if="outshowMoney">{{outmoneyTip}}</p>
                <div class="ts_content_frout">
                    <p class="pout">支付宝账号：</p>
                    <input v-model="zfb" class="text-inputout" type="text" placeholder="请输入支付宝账号"/>
                </div>
                <p class="red-pout" v-if="showZfb">请输入支付宝账号</p>
                <button class="btn-150out" @click="submitoutMoney">申请提现</button>
            </div>
        </generalframe>
        <!-- 激活码兑换 -->
        <generalframe @fatherMethod="fatherModal" v-show="showActivityCode" maintitle="会员激活码兑换">
            <div class="ts_contentout">
                <div class="ts_content_frout">
                    <p class="pout" style="width: 42px;"></p>
                    <input v-model="activityCode" class="text-inputout" placeholder="请输入会员激活码" type="text"/>
                </div>
                <button class="btn-150out" @click="exchange">兑换</button>
            </div>
        </generalframe>
<!--        <activity-code @fatherMethod="showActivityCode=false" v-if="showActivityCode"/>-->
<!--        <activity-code @fatherMethod="fatherModal" v-if="showActivityCode"/>-->
    </div>
</template>
<script>
    import {
        getHuaWeiToken,
        getMemberMyOrder,
        postEmailCode,
        postEmailBind,
        postLoginSendSmsCode,
        postUpdatePassword,
        userModifyPicture,
        userModifyName
    } from '@/api/staticPage';
    import Cookies from "js-cookie";
    import {userInfo} from "@/api/index";
    import {_drawMoney, _inputInviteCode, _getMoney} from "@/api/wallet.js";
    import generalframe from './../../vip/lawcomponent/generalframe.vue'
    import mycapay from './../../vip/lawcomponent/myczpay.vue';
    import {_exchange} from "../../../../api/activity";
    // import activityCode from "./activityCode";

    const documnetType = 20971520;
    const pictureType = 20971520 * 5;
    const videoAndMusic = 20971520 * 5 * 5;
    const otherType = 20971520 * 5 * 2;
    const HWC_KEY = "https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar"
    const type = ['bat', 'exe', 'com', 'DLL', 'MSI', 'VBS', 'VBE', 'JS', 'JSE', 'WSH', 'WSF', 'PBD', 'PB', 'dmg', 'fcd', 'gdb', 'REG', 'SAV', 'str', 'SYS', 'swf', 'VBP', 'VBW', 'VBX', 'VIR', 'VXD', 'WCM', 'WIZ', 'A', 'ADF'];
    const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
    String.prototype.suffix = function () {
        var index1 = this.lastIndexOf(".");
        var index2 = this.length;
        return this.substring(index1 + 1, index2)
    }
    var globalContext = {};
    globalContext.maxTaskNum = 5;
    globalContext.currentTaskNum = 0;
    const _doUpload = (obsClient, uploadPartStatus) => new Promise((res, rej) => {
        var events = require('events');
        var allDoneEe = new events.EventEmitter();
        doUploadPart(obsClient, uploadPartStatus, allDoneEe);
        allDoneEe.on('upload part finished', (result, _parts) => {
            res(result, _parts);
        });
        allDoneEe.on('error', (err) => {
            rej(err);
        });
    });
    const doUploadPart = (obsClient, uploadPartStatus, allDoneEe) => {
        while (uploadPartStatus.currentPartIndex < uploadPartStatus.partCount && globalContext.currentTaskNum < globalContext.maxTaskNum) {
            var offset = uploadPartStatus.currentPartIndex * uploadPartStatus.partSize;
            var currPartSize = (uploadPartStatus.currentPartIndex + 1 === uploadPartStatus.partCount) ? uploadPartStatus.fileSize - offset : uploadPartStatus.partSize;
            var partNumber = uploadPartStatus.currentPartIndex + 1;
            uploadPartStatus.currentPartIndex++;
            globalContext.currentTaskNum++;
            var getCallback = function (partNumber) {
                return function (result) {
                    globalContext.currentTaskNum--;
                    doUploadPart(obsClient, uploadPartStatus, allDoneEe);
                    if (result.CommonMsg.Status < 300) {
                        console.log('Part:' + partNumber + ' finished, etag:' + result.InterfaceResult.ETag);
                        uploadPartStatus.parts.push({PartNumber: partNumber, ETag: result.InterfaceResult.ETag});
                        if (uploadPartStatus.parts.length === uploadPartStatus.partCount) {
                            var _parts = uploadPartStatus.parts.sort(function (a, b) {
                                if (a.PartNumber >= b.PartNumber) {
                                    return 1;
                                }
                                return -1;
                            });
                            obsClient.completeMultipartUpload({
                                Bucket: uploadPartStatus.bucketName,
                                Key: uploadPartStatus.objectKey,
                                UploadId: uploadPartStatus.uploadId,
                                Parts: _parts
                            }, function (err, result) {
                                if (!err && result.CommonMsg.Status < 300) {
                                    console.log('Complete to upload multiparts finished.\n');
                                    allDoneEe.emit('upload part finished', result, _parts);
                                } else {
                                    var msg = err || result.CommonMsg.Code;
                                    console.error(msg);
                                    allDoneEe.emit('error', msg);
                                }
                            });
                        }
                    } else {
                        console.error(result.CommonMsg.Code);
                        allDoneEe.emit('error', result.CommonMsg.Code);
                    }
                }
            };
            obsClient.uploadPart({
                Bucket: uploadPartStatus.bucketName,
                Key: uploadPartStatus.objectKey,
                PartNumber: partNumber,
                UploadId: uploadPartStatus.uploadId,
                SourceFile: uploadPartStatus.file,
                Offset: offset,
                PartSize: currPartSize
            }).then(getCallback(partNumber)).catch(function (err) {
                console.error('err:' + err);
                allDoneEe.emit('error', err);
            });
        }
    };
    export default {
        metaInfo: {
            title: '会员信息|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '会员信息,前海版权服务平台,人人都是创作者，人人都是版权人。前海版权服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'memberInfo',
        components: {
            generalframe,
            mycapay,
        },
        data() {
            return {
                activityCode:"",
                serverList: {},
                userPhoto: require('@/assets/head.png'),
                userRealPhoto: '',
                nickThankName: '',
                showPerEnter: 'Y',
                vipEndDate: '',
                ifVIP: '',
                vipName: '',
                vipOverdue: 0, //会员过期标志 0 不过期  1 过期
                showSmId: '',
                userInfo: '',
                shimingopen: require('@/assets/shiming-open.png'),
                shimingclose: require('@/assets/unrealname.png'),
                wxpicture: require('@/assets/images/new_lo_wx.png'),
                qqpicture: require('@/assets/images/new_lo_qq.png'),
                weibopicture: require('@/assets/images/new_lo_weibo.png'),
                wxpicturecolor: require('@/assets/images/new_lo_wxcol.png'),
                qqpicturecolor: require('@/assets/images/new_lo_qqcol.png'),
                weibopicturecolor: require('@/assets/images/new_lo_weibocol.png'),
                showDialog: !1,
                showDialog02: !1,
                showDialog03: !1,
                typeverifyCode: '',
                email: '',
                verifyCode_time: '获取验证码',
                ver_disabled: 'unset',
                verifyCode_time_dx: '发送验证码',
                ver_disabled_dx: 'unset',
                verifyCode: '',
                password: '',
                nextPassword: '',
                mobilePhone: '',
                showEditVertial: 'N',
                nickName: '',
                showEmail: false,
                showEmailCode: false,
                showPhoneCode: false,
                showOneCode: false,
                showTwoCode: false,
                inviteCodeImg: "",
                inviteCode: "",
                inviteNumber: 0,
                totalSum: 0,
                truthMoney: 0,
                frozenAmount: 0,
                inviteUrl: "",
                showDialog07: !1,
                money: "",
                moneyTip: "请输入转出金额",
                showMoney: false,
                showDialog01: !1,
                showInviteNumber: false,
                inviteNumberCode: "",
                joinInviteCode: "",
                inputFlag: null,
                accountNum: "",
                showModal: false,
                outmoney: "",
                zfb: "",
                outmoneyTip: "请输入提现金额",
                outshowMoney: false,
                showZfb: false,
                showActivityCode: false, //显示激活码框
                tip: "不可提现（订单成功支付后，邀请佣金将在预计奖励金账户显示，若20个自然日内用户发起退款，系统将自动扣除该笔订单奖励金；20个自然日内若未发生退款，系统自动发起审核提交至人工复核，复核后，该笔订单奖励将从预计奖励金账户中扣除，转发至已获奖励账户中）"
            }
        },
        created() {
            let _this = this;
            let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
            console.log(userInfo)
            this.userInfo = userInfo
            this.accountNum = userInfo.account ? userInfo.account : '';
            this.mobilePhone = userInfo.mobilePhone ? userInfo.mobilePhone : '';
            this.userRealPhoto = userInfo.photo ? userInfo.photo : this.userPhoto;
            this.nickThankName = userInfo.nickName ? userInfo.nickName : userInfo.account;
            this.vipEndDate = userInfo.vipEndDate ? userInfo.vipEndDate.split(' ')[0] : '';
            this.ifVIP = userInfo.vipFlag ? userInfo.vipFlag : '';
            this.vipName = userInfo.medalName ? userInfo.medalName : 'VIP会员';
            this.vipOverdue = userInfo.vipOverdue ? userInfo.vipOverdue : '';
            this.showSmId = userInfo.id ? userInfo.id : '';
            this.showPerEnter = userInfo.accountType ? userInfo.accountType == 'person' ? 'Y' : 'N' : ''
            // this.emailBindStatus = userInfo.emailBindStatus?userInfo.emailBindStatus:0;
        },
        methods: {
            //更改到期时间
            updateVipData(data) {
                this.vipEndDate = data
            },
            //邀请
            getCode() {
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                let registerId = userInfo && userInfo.id ? userInfo.id : ''
                this.getRequest('/registerInviteCode/getData/' + registerId).then(res => {
                    if (res.code == 200) {
                        this.inviteCodeImg = res.result.qrCode;
                        this.inviteCode = res.result.inviteCode;
                        this.inviteNumber = res.result.inviteNumber ? res.result.inviteNumber : 0;
                        this.totalSum = res.result.totalSum ? res.result.totalSum : 0;
                        this.truthMoney = res.result.amount ? res.result.amount : 0;
                        this.frozenAmount = res.result.frozenAmount ? res.result.frozenAmount : 0;
                        this.inviteUrl = res.result.inviteUrl;
                        this.joinInviteCode = res.result.joinInviteCode;
                        this.inputFlag = res.result.inputFlag;
                        if(userInfo.vipFlag=='1' && res.result.inputFlag == '0'){
                            this.inputFlag="-1";
                        }
                    }
                })
            },
            //复制
            onCopy(e) {
                toast("复制成功，请在手机中查看");
            },
            onError(e) {
                toast("复制失败");
            },
            //触发转出
            goMoney() {
                this.showDialog07 = !0;
                this.showMoney = false;
            },
            fatherMethod07() {
                this.showDialog07 = !1;
                this.money = "";
                this.showMoney = false;
            },
            //转出到钱包
            submitMoney() {
                if (Number(this.money) >= 10 && Number(this.money) <= Number(this.truthMoney) && !(this.showMoney)) {
                    this.showMoney = false;
                    let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    const data = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                        amount: this.money,
                    }
                    _drawMoney(data).then(res => {
                        if (res.code == 200) {
                            this.showDialog07 = !1;
                            toast("转出到我的钱包成功")
                            this.money = "";
                            this.$router.push({name: 'wallet'})
                        } else {
                            toast(res.message)
                        }
                    });
                } else {
                    this.showMoney = this.showMoney || !this.money
                }
            },
            //提现-弹框
            fatherMethodMoney() {
                this.showModal = false;
                this.outmoney = "";
                this.zfb = "";
                this.outshowMoney = false;
                this.showZfb = false;
            },
            getoutMoney() {
                this.showModal = true;
                this.outshowMoney = false;
                this.showZfb = false;
            },
            //提现
            submitoutMoney() {
                if ((10 <= Number(this.outmoney) <= Number(this.truthMoney) && this.zfb) && !(this.outshowMoney || this.showZfb)) {
                    this.outshowMoney = false;
                    this.showZfb = false;
                    let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    const data = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                        drawWay: "alipay",
                        drawAccount: this.zfb,
                        drawAmount: this.outmoney,
                        drawOrigin: 'commission'
                    }
                    _getMoney(data).then(res => {
                        if (res.code == 200) {
                            this.showModal = false;
                            toast("提交申请成功")
                            this.outmoney = "";
                            this.zfb = "";
                            this.$router.push({name: 'invite'})
                        } else {
                            toast(res.message)
                        }
                    });
                } else {
                    this.outshowMoney = this.outshowMoney || !this.outmoney
                    this.showZfb = this.showZfb || !this.zfb
                }
            },
            //兑换激活码
            exchange(){
                let codeReg = /^[0-9a-zA-Z]+$/ ;
                if(!codeReg.test(this.activityCode)){
                    toast("请输入正确的激活码，激活码只包含数字和字母")
                    return false ;
                }else if(this.activityCode.length >32){
                    toast("请输入正确的激活码，激活码不会超过32位")
                }
                let params = {
                    code: this.activityCode
                };
                let _this = this ;
                console.log("code ::: ",params);
                _exchange(params).then((res)=>{
                    if(res.code == "200"){
                        debugger ;
                        toast("兑换成功")
                        _this.showActivityCode = false ;
                        _this.getUserStaus() ;
                    }else{

                    }
                });
            },


            //邀请码
            goCodeNumber() {
                this.showDialog01 = !0;
                this.showInviteNumber = false;
            },
            fatherMethodCode() {
                this.showDialog01 = !1;
                this.showInviteNumber = false;
                this.inviteNumberCode = "";
            },
            submitNumber() {
                if (this.inviteNumberCode) {
                    this.showInviteNumber = false;
                    let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    const data = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                        inviteCode: this.inviteNumberCode
                    }
                    _inputInviteCode(data).then(res => {
                        if (res.code == 200) {
                            this.showDialog01 = !1;
                            this.getCode()
                        } else {
                            toast(res.message)
                        }
                    })
                } else {
                    this.showInviteNumber = true
                }
            },
            editSave() {
                let _this = this;
                if (_this.nickThankName.replace(/[, ]/g, '') == '') {
                    toast('用户昵称不能为空')
                    return false;
                }
                userModifyName({
                    id: _this.userInfo.id ? _this.userInfo.id : '',
                    nickName: _this.nickThankName
                }).then(res => {
                    console.log('+++++++++++++++++++', res)
                    if (res.code == 200) {

                        _this.showEditVertial = 'N'
                        userInfo().then(res => {
                            console.log("?????????????????????", res)
                            if (res.code == 200) {
                                // 避免超过大小限制

                                Cookies.set("userInfo", JSON.stringify(res.result));
                            }
                        });
                    }
                })
            },
            edit() {
                this.showEditVertial = 'Y'
            },
            editCancel() {
                this.showEditVertial = 'N'
                this.nickName = ''
            },
            immediatePayment() {
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                // console.log(userInfo)
                this.$router.push({
                    name: "openVip",
                    query:{
                        type:userInfo.medalName
                    },
                });
                // this.showDialog03 = !0
            },
            surePassword() {
                if ((this.verifyCode && this.password && this.nextPassword) && !(this.showPhoneCode || this.showOneCode || this.showTwoCode)) {
                    this.showPhoneCode = false;
                    this.showOneCode = false;
                    this.showTwoCode = false;
                    let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    let params = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                        mobilePhone: this.accountNum,
                        verifyCode: this.verifyCode,
                        password: this.password,
                        nextPassword: this.nextPassword,
                    }
                    postUpdatePassword(params).then(res => {
                        if (res.code == 200) {
                            toast("修改密码成功")
                            this.showDialog02 = !1;
                            this.verifyCode = '';
                            this.password = '';
                            this.nextPassword = '';
                            this.verifyCode_time_dx = '发送验证码';
                        } else {
                            toast(res.message)
                        }
                    })
                } else {
                    this.showPhoneCode = this.showPhoneCode || !this.verifyCode;
                    this.showOneCode = this.showOneCode || !this.password;
                    this.showTwoCode = this.showTwoCode || !this.nextPassword;
                }
            },
            _getLoginSendSmsCode(type) {
                let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                let emailReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
                if (myreg.test(this.accountNum)) {
                    let params = {
                        mobile: this.accountNum,
                        type: type
                    }
                    postLoginSendSmsCode(params).then(res => {
                        console.log('发送验证码成功', res)
                        if (res.code == 200) {
                            this.verifyCode_time_dx = 60
                            this.ver_disabled_dx = 'none'
                            const timerSchool = setInterval(() => {
                                if (this.verifyCode_time_dx > 0 && this.verifyCode_time_dx <= 60) {
                                    this.verifyCode_time_dx = this.verifyCode_time_dx - 1
                                } else {
                                    clearInterval(timerSchool);
                                    this.verifyCode_time_dx = '发送验证码'
                                    this.ver_disabled_dx = 'unset'
                                }
                            }, 1000)
                        }
                    })
                } else if (emailReg.test(this.accountNum)) {
                    let params = {
                        email: this.accountNum,
                        type: type
                    }
                    postEmailCode(params).then(res => {
                        if (res.code == 200) {
                            this.verifyCode_time_dx = 60
                            this.ver_disabled_dx = 'none'
                            const timerSchool = setInterval(() => {
                                if (this.verifyCode_time_dx > 0 && this.verifyCode_time_dx <= 60) {
                                    this.verifyCode_time_dx = this.verifyCode_time_dx - 1
                                } else {
                                    clearInterval(timerSchool);
                                    this.verifyCode_time_dx = '发送验证码'
                                    this.ver_disabled_dx = 'unset'
                                }
                            }, 1000)
                        }
                    })
                }
            },
            bandsubmit() {
                let _this = this;
                if ((_this.email && _this.typeverifyCode) && !(_this.showEmail || _this.showEmailCode)) {
                    _this.showEmail = false;
                    _this.showEmailCode = false;
                    let userInfos = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    let params = {
                        verifyCode: this.typeverifyCode,
                        registerId: userInfos && userInfos.id ? userInfos.id : '',
                        email: this.email,
                    }
                    postEmailBind(params).then(res => {
                        console.log('绑定邮箱接口是否成功', res)
                        if (res.code == 200) {
                            this.showDialog = !1
                            toast('邮箱绑定成功');
                            this.getUserStaus();
                            // userInfo().then(res => {
                            //     console.log("?????????????????????",res)
                            //     if (res.code==200) {
                            //         // 避免超过大小限制
                            //         Cookies.set("userInfo", JSON.stringify(res.result));
                            //         userInfoLast = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                            //         _this.userInfo = userInfoLast
                            //     }
                            // });
                        } else {
                            toast(res.message)
                        }
                    })
                } else {
                    _this.showEmail = _this.showEmail || !_this.email
                    _this.showEmailCode = _this.showEmailCode || !_this.typeverifyCode
                }
            },
            goLookfoe() {
                if (this.ifVIP == 1 || this.ifVIP == 2) {
                    this.$router.push({
                        path: '/look-member'
                    })
                } else {
                    toast("请开通会员")
                }
            },
            _postLoginSendSmsCode(type) {
                if (this.email == '') {
                    this.showEmail = true
                    return false
                }
                let params = {
                    email: this.email,
                    type: type
                }
                this.ver_disabled = 'none'
                postEmailCode(params).then(res => {
                    if (res.code == 200) {
                        this.verifyCode_time = 60
                        const timer = setInterval(() => {
                            if (this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
                                this.verifyCode_time = this.verifyCode_time - 1
                            } else {
                                clearInterval(timer);
                                this.verifyCode_time = '获取验证码'
                                this.ver_disabled = 'unset'
                            }
                        }, 1000)
                        console.log('获取的邮箱的验证码', res)
                    } else {
                        toast(res.message)
                    }
                })
            },
            sureOrder() {
                let _this = this;
                _this.bandsubmit()
            },
            bangding() {
                this.showDialog = !0;
                this.showEmail = false;
                this.showEmailCode = false;
            },
            setpassword() {
                this.showDialog02 = !0;
                this.showPhoneCode = false;
                this.showOneCode = false;
                this.showTwoCode = false;
            },
            fatherMethod() {
                let _this = this;
                _this.showDialog = !1
                _this.showDialog02 = !1
                _this.showEmail = false;
                _this.showEmailCode = false;
                _this.email = '';
                _this.typeverifyCode = '';
                _this.showPhoneCode = false;
                _this.showOneCode = false;
                _this.showTwoCode = false;
                _this.verifyCode = '';
                _this.password = '';
                _this.nextPassword = '';
            },
            //激活码兑换,续费后，重新获取用户信息，用于更新会员状态
            fatherModal() {
                this.showDialog03 = !1;
                this.showActivityCode=false;
                this.getUserStaus() ;
            },
            _getMemberMyOrder() {
                let _this = this;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                console.log('+++++++++++++++++', userInfo)
                let params = {
                    registerId: userInfo && userInfo.id ? userInfo.id : '',
                }
                getMemberMyOrder(params).then(res => {
                    if (res.code == 200) {
                        this.serverList = res.result
                    }
                })
            },
            goVIPSchool() {
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                //一、未开通会员情况：1.未实名。2.已实名
                if (this.ifVIP != 1) {
                    //未实名
                    if (userInfo.realNameStatus != 'complete_real_name') {
                        this.$router.push({path: '/authentication'})
                    }
                    //已实名
                    else {
//                        if (this.showPerEnter == 'Y') {
//                            this.$router.push({path: '/vipPersonal'})
//                        } else {
//                            this.$router.push({path: '/vipEnterprise'})
//                        }
                        // this.$router.push({path: '/huiyuan.html'})
                        // this.$router.push({path: '/openVip'})
                        this.$router.push({
                            name: "openVip",
                            query:{
                                type:""
                            },
                        });
                    }
                }
                //二、已开通会员情况：去会员权益页面
                else {
                    this.$router.push({path: '/look-member'})
                }
            },
            goFirPage() {
                this.$router.push({path: '/huiyuan.html'})
            },
            goAuthentication() {
                let _this = this;
                if (this.showPerEnter == 'Y') {
                    this.$router.push({
                        path: '/personalAuthentication',
                        query: {
                            id: _this.showSmId
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/enterpriseAuthentication1',
                        query: {
                            id: _this.showSmId
                        }
                    })
                }
            },
            getActivityCode() {
                this.showActivityCode = true;
            },
            handleSuccess(res, file) {
                file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                file.name = '7eb99afb9d5f317c912f08b5212fd69a';
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '超出单个存证对文件最大限制',
                    desc: '超出单个存证对文件最大限制, 所有类型累计不能超过820M.'
                });
            },
            handleBeforeUpload: async function (file) {
                await this._getHuaWeiToken();
                var tempdocument = 0;
                var temppicture = 0;
                var tempmv = 0;
                var tempother = 0;
                let _this = this
                var filetype = file.name.suffix()
                if (file.size > documnetType) {
                    this.$Notice.warning({
                        title: '超出最大允许上传上限',
                        desc: '文件上传不能超过20M'
                    });
                    return false;
                }
                let fileReader = new FileReader(),
                    blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
                    chunkSize = 2097152,
                    chunks = Math.ceil(file.size / chunkSize),
                    currentChunk = 0,
                    spark = new SparkMD5.ArrayBuffer();
                const loadNext = () => {
                    var start = currentChunk * chunkSize,
                        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                };
                loadNext();
                fileReader.onload = (e) => {
                    spark.append(e.target.result);
                    currentChunk++;
                    if (currentChunk < chunks) {
                        loadNext();
                    } else {
                        this.md5Hash = spark.end();
                        console.log('???????????????????????', this.md5Hash)
                        var mdfives = this.md5Hash
                        if (this.md5Hash != '') {
                            var partSize = 2097152;
                            var fileSize = file.size;
                            console.log('+++++++++++++++++++++++++', _this.accessKeyId, _this.accessKeySecret, _this.stsToken)
                            var obsClient = _this.getObsClient();
                            obsClient.initiateMultipartUpload({
                                Bucket: "anne-bqj-file",
                                Key: "file/" + mdfives + "." + file.name.substring(file.name.lastIndexOf(".") + 1)
                                // Key:"file/" + file.name
                            }).then(function (result) {
                                console.log('最终获取到华为云obs的结果', result)
                                var uploadId = result.InterfaceResult.UploadId;
                                console.log('uploadId:' + uploadId);
                                var partCount = fileSize % partSize === 0 ? Math.floor(fileSize / partSize) : Math.floor(fileSize / partSize) + 1;
                                console.log('partCount:' + partCount);
                                var uploadPartStatus = {
                                    bucketName: "anne-bqj-file",
                                    objectKey: result.InterfaceResult.Key,
                                    uploadId: uploadId,
                                    file: file,
                                    fileSize: fileSize,
                                    partSize: partSize,
                                    partCount: partCount,
                                    currentPartIndex: 0,
                                    parts: []
                                };
                                _doUpload(obsClient, uploadPartStatus).then((doneResult, _parts) => {
                                    console.log(`done signal is: ${doneResult}, ${_parts}`);
                                    let layout = uploadPartStatus.objectKey.substring(uploadPartStatus.objectKey.lastIndexOf(".") + 1);
                                    // _this.uploadList = [{
                                    //     uid: file.uid,
                                    //     name: file.name,
                                    //     status: 'done',
                                    //     type: file.type,
                                    //     md5Hash:mdfives,
                                    //     url:'http://file.bqj.cn/'+result.InterfaceResult.Key,
                                    //     result:HWC_KEY + result.InterfaceResult.Key,
                                    // }]
                                    // _this.fileName = file.name;
                                    userModifyPicture({
                                        id: _this.userInfo.id ? _this.userInfo.id : '',
                                        photo: 'http://file.bqj.cn/' + result.InterfaceResult.Key
                                    }).then(res => {
                                        if (res.code == 200) {
                                            _this.userRealPhoto = 'http://file.bqj.cn/' + result.InterfaceResult.Key;
                                            userInfo().then(res => {
                                                console.log("?????????????????????", res)
                                                if (res.code == 200) {
                                                    // 避免超过大小限制
                                                    Cookies.set("userInfo", JSON.stringify(res.result));
                                                    let photo = res.result.photo ? res.result.photo : ''
                                                    _this.$emit('childFn', photo);
                                                    _this.$store.commit("setAvatarPath", photo);
                                                    // 加载菜单
                                                    // let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
                                                    // _this.$router.push(NewPage);
                                                    // _this.$router.go(-1);
                                                }
                                            });
                                        }
                                    })
                                    return false;
                                }).catch(e => {
                                    console.error(e);
                                });
                            }).catch(e => {
                                console.error(e);
                            });
                        }
                    }
                }
                // this.getObsClient()
            },
            _getHuaWeiToken: async function () {
                await getHuaWeiToken().then((res) => {
                    console.log('获取的华为云的临时cookie', res)
                    if (res.code == 200) {
                        this.accessKeyId = res.result.accessKeyId;
                        this.accessKeySecret = res.result.accessKeySecret;
                        this.stsToken = res.result.securityToken;
                    }
                })
            },
            getObsClient() {
                let _this = this
                var obsClient = new window.ObsClient({
                    access_key_id: _this.accessKeyId,
                    secret_access_key: _this.accessKeySecret,
                    security_token: _this.stsToken,
                    server: "obs.cn-north-4.myhuaweicloud.com",
                    timeout: 60 * 5,
                })
                return obsClient;
            },
            getUserStaus() {
                userInfo().then(res => {
                    if (res.code == 200) {
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        this.setStore("userInfo", res.result);
                        this.userInfo = res.result;
                        this.userInfo.emailBindStatus == res.result.emailBindStatus;
                        this.vipName = res.result.medalName ? res.result.medalName : 'VIP会员';
                        this.vipEndDate = res.result.vipEndDate ? res.result.vipEndDate.split(' ')[0] : '';
                        this.ifVIP = res.result.vipFlag ? res.result.vipFlag : '';
                    }
                })
            },
            bindOther(index) {
                let userInfo = this.userInfo;
                let API_ROOT_UPLOAD = this.API_ROOT_UPLOAD;
                let protocol = window.location.protocol;
                let host = window.location.host;
                switch (index) {
                    //微信
                    case 0:
                        if (userInfo.weixinFlag == 0) {
                            window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/weixin/auth?backurl=${protocol}${host}`;
                        }
                        break;
                    //QQ
                    case 1:
                        if (userInfo.qqFlag == 0) {
                            window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/qq/auth?backurl=${protocol}${host}`;
                        }
                        break;
                    //微博
                    case 2:
                        if (userInfo.weiboFlag == 0) {
                            window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/weibo/auth?backurl=${protocol}${host}`;
                        }
                        break;
                }
            }
        },
        mounted() {
            this.getUserStaus();
            this._getMemberMyOrder();
            this.getCode();
        },
        watch: {
            'typeverifyCode': {
                handler: function () {
                    if (this.typeverifyCode) {
                        this.showEmailCode = false
                    } else {
                        this.showEmailCode = true
                    }
                }
            },
            'email': {
                handler: function () {
                    var emailReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
                    if (emailReg.test(this.email)) {
                        this.showEmail = false
                    } else {
                        this.showEmail = true
                    }
                }
            },
            'verifyCode': {
                handler: function () {
                    if (this.verifyCode) {
                        this.showPhoneCode = false
                    } else {
                        this.showPhoneCode = true
                    }
                }
            },
            'password': {
                handler: function () {
                    if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(this.password) && this.password != '') {
                        this.showOneCode = false
                    } else {
                        this.showOneCode = true
                    }
                }
            },
            'nextPassword': {
                handler: function () {
                    if (this.nextPassword == this.password && this.nextPassword != '') {
                        this.showTwoCode = false
                    } else {
                        this.showTwoCode = true
                    }
                }
            },
            'money': {
                handler: function () {
                    let re = /^\d+(\.\d{1,2})?$/;
                    if (re.test(this.money)) {
                        if (Number(this.money) <= Number(this.truthMoney)) {
                            if (Number(this.money) < 10) {
                                this.moneyTip = "转出金额不得低于10元"
                                this.showMoney = true;
                            } else {
                                this.moneyTip = ""
                                this.showMoney = false;
                            }
                        } else {
                            this.moneyTip = "当前可转出余额不足"
                            this.showMoney = true;
                        }
                    } else {
                        this.moneyTip = "请输入正整数金额或最多保留两位小数"
                        this.showMoney = true;
                    }
                }
            },
            'inviteNumberCode': {
                handler: function () {
                    let re = /^[0-9]*$/;
                    if (re.test(this.inviteNumberCode)) {
                        this.showInviteNumber = false
                    } else {
                        this.showInviteNumber = true
                    }
                }
            },
            'outmoney': {
                handler: function () {
                    let re = /^[0-9]*$/;
                    if (re.test(this.outmoney)) {
                        if (Number(this.outmoney) <= Number(this.truthMoney)) {
                            if (Number(this.outmoney) < 10) {
                                this.outmoneyTip = "提现金额不得低于10元"
                                this.outshowMoney = true;
                            } else {
                                this.outmoneyTip = ""
                                this.outshowMoney = false;
                            }
                        } else {
                            this.outmoneyTip = "当前可提现余额不足"
                            this.outshowMoney = true;
                        }
                    } else {
                        this.outmoneyTip = "请输入正整数金额"
                        this.outshowMoney = true;
                    }
                }
            },
            'zfb': {
                handler: function () {
                    if (this.zfb) {
                        this.showZfb = false
                    } else {
                        this.showZfb = true
                    }
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .btn-span {
        display: inline-block;
        border: 0px;
        background: transparent;
        outline: none;
        color: #666;
        font-size: 14px;
        text-decoration: underline;
        cursor: pointer;
    }

    .title {
        width: 756px;
        height: 58px;
        line-height: 58px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 18px 0px rgba(211, 214, 225, 0.15);
        border-radius: 8px 8px 0px 0px;

        span, a {
            font-size: 12px;
            color: rgba(102, 102, 102, 1);
        }

        a {
            text-decoration: underline;
        }
    }

    .memberInfo-top {
       flex: 1;
        margin: 25px;
        display: flex;
        justify-content: space-between;

        .memberInfo-top-left {
            width: 100%;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 18px 0px rgba(211, 214, 225, 0.15);
            border-radius: 8px;
            .memberInfo-header {
                padding: 17px 23px;
                border-radius: 8px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 18px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);

                .nickThankName {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 14px;
                    margin-left: 16px;
                    .t{
                        font-size: 20px;
                        font-weight: 700;
                        color: #333;
                        margin-bottom: 6px;
                    }
                }

                .editbutton {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .showedit {
                        width: 154px;
                        height: 30px;
                        font-size: 14px;
                        border-radius: 4px;
                        border: solid 1px #E5E5E5;
                        box-shadow: none;
                        padding: 0 10px;
                    }

                    .showbutton {
                        width: 70px;
                        flex: 0 0 70px;
                        height: 30px;
                        font-size: 12px;
                        color: #fff;
                        background: #2196F3;
                        border: none;
                        outline: none;
                        cursor: pointer;
                    }
                    .showbuttonQ {
                        width: 70px;
                        flex: 0 0 70px;
                        height: 30px;
                        font-size: 12px;
                        color: #BDBDBD;
                        background: #2196F3;
                        border: none;
                        outline: none;
                        cursor: pointer;
                        border-radius: 4px;
                    }
                }

                /deep/ .ivu-upload-drag {
                    border: none;
                }

                .header-img {
                    width: 80px;
                    height: 80px;
                }

                .bianji-img {
                    width: 12px;
                    height: 12px;
                    cursor: pointer;
                }
            }

            .memberInfo-left-p {
                margin: 0 25px;

                p {
                    margin-top: 20px;
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    color: rgba(102, 102, 102, 1);

                    img {
                        width: 20px;
                        height: 20px;
                        vertical-align: middle;
                        margin-right: 10px;
                    }
                }

                a {
                    float: right;
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                    text-decoration: underline;
                }

                .btn-277 {
                    width: 277px;
                    height: 29px;
                    line-height: 29px;
                    border: 0;
                    outline: none;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(78, 78, 78, 1);
                    cursor: pointer;
                    margin-bottom: 8px;
                }
            }
        }

        .invite-top {
            width: 756px;
            height: 271px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 18px 0px rgba(211, 214, 225, 0.15);
            border-radius: 8px;

            .stopDear {
                font-size: 30px;
                font-weight: bold;
                text-align: center;
                height: 271px;
                line-height: 271px;
            }

            .invite-ul {
                height: 173px;
                width: 756px;
                margin: 20px auto;
                overflow: hidden;

                li {
                    height: 173px;
                    float: left;
                    font-size: 14px;
                    color: #666;
                    overflow: hidden;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 2px 18px 0px rgba(211, 214, 225, 0.15);
                    border-radius: 2px;
                }

                .li-one {
                    width: 105px;
                    text-align: center;

                    img {
                        width: 100px;
                        height: 100px;
                        margin: 28px 0px 20px;
                    }

                    p {
                        font-size: 12px;
                        color: rgba(51, 51, 51, 1);
                        line-height: 17px;
                    }
                }

                .li-two {
                    width: 250px;
                    margin: 0px 6px;

                    .line {
                        width: 220px;
                        height: 1px;
                        background: rgba(249, 249, 249, 1);
                        margin: 0 auto;
                        margin-bottom: 20px;
                    }

                    p {
                        line-height: 20px;

                        img {
                            height: 20px;
                            width: 20px;
                            vertical-align: middle;
                        }

                        span {
                            vertical-align: middle;
                        }
                    }
                }
            }
        }
    }

    .memberInfo-center {
        flex: 1;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 18px 0px rgba(211, 214, 225, 0.15);
        border-radius: 8px;
        margin: 25px;

        .myService {
            margin: 50px 0px 0px 54px;
            height: 49px;

            li {
                list-style: none;
                float: left;
                width: 220px;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                img {
                    height: 49px;
                    width: 49px;
                    vertical-align: middle;
                }

                p {
                    font-size: 14px;
                    line-height: 20px;
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }

    .notwrap {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        white-space: normal;
        overflow: hidden;
    }

    .memberInfo-link {
        display: flex;
        align-items: center;
        height: 117px;
        li {
           flex: 1;
            list-style: none;
            .newItme{
                display: flex;
                justify-content: center;
                img{
                    width: 24px;
                    height: 24px;
                }
                .text{
                    font-size: 14px;
                    margin-left: 10px;
                    a {
                        font-size: 12px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        text-decoration: underline;
                        margin-left: 10px;
                    }
                }
            }

            .img-box {
                height: 25px;
                margin-left: 35px;

                img {
                    height: 25px;
                    width: 25px;
                    vertical-align: middle;
                    // cursor: pointer;
                    &.active {
                        cursor: none;
                        pointer-events: none;
                    }
                }
            }
        }
    }

    .ts_content {
        padding: 30px;

        .ts_content_fr {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            p {
                width: 75px;
                text-align: left;
                // margin-right:10px;
                line-height: 46px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(50, 50, 50, 1);
            }

            input {
                width: 295px;
                height: 44px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(222, 226, 230, 1);
                line-height: 46px;
                text-indent: 10px;
            }
        }
    }

    .goOrderEsc {
        width: 150px;
        height: 37px;
        background: #2196F3;
        border-radius: 21px;
        margin-top: 20px;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        line-height: 37px;
        outline: none;
        border: none;
        cursor: pointer;
    }

    .emailRelative {
        position: relative;
        width: 295px;
        height: 44px;

        input {
            position: absolute;
            left: 0;
            top: 0;
        }

        .loginVertialsf {
            position: absolute;
            right: 10px;
            width: 85px;
            height: 28px;
            background: #2196F3;
            border-radius: 4px;
            top: 9px;
            font-size: 12px;
            font-weight: 400;
            color: #fff;
            line-height: 28px;
            cursor: pointer;
            outline: none;
            border: none;
        }
    }

    .loginVertial {
        width: 85px;
        height: 28px;
        background: #2196F3;
        border-radius: 4px;
        top: 9px;
        font-size: 12px;
        font-weight: 400;
        color: #fff;
        line-height: 28px;
        cursor: pointer;
        outline: none;
        border: none;
        display: inline-block;

    }

    .red-p {
        color: #f00;
        text-align: left;
        margin-left: 59px;
    }

    .btn-150 {
        width: 150px;
        height: 37px;
        outline: none;
        border: 0px;
        background: rgba(255, 216, 0, 1);
        border-radius: 21px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
        cursor: pointer;
        position: absolute;
        bottom: 55px;
        left: 135px;
    }

    .ts_contentout {
        overflow: hidden;
        height: 230px;
        position: relative;

        .ts_content_frout {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 30px;

            .pout {
                width: 85px;
                text-align: left;
                margin-right: 10px;
                margin-left: 30px;
                color: rgba(50, 50, 50, 1);
            }

            .text-inputout {
                width: 252px;
                height: 46px;
                outline: none;
                border-radius: 4px;
                border: 1px solid rgba(222, 226, 230, 1);
                text-indent: 10px;
                color: rgba(50, 50, 50, 1);
            }
        }

        .btn-150out {
            width: 150px;
            height: 37px;
            outline: none;
            border: 0px;
            background: rgba(255, 216, 0, 1);
            border-radius: 21px;
            font-size: 14px;
            font-weight: 600;
            color: rgba(78, 78, 78, 1);
            cursor: pointer;
            position: absolute;
            bottom: 0px;
            left: 135px;
        }

        .red-pout {
            color: #f00;
            text-align: left;
            margin-left: 125px;
        }
    }

    .awardMoney /deep/ .ivu-tooltip-inner {
        word-break: break-all;
        white-space: normal;
        min-width: 400px !important;
        min-height: 140px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px !important;
        padding-top: 16px;
        padding-left: 17px;
    }

    .awardMoney /deep/ .ivu-tooltip-arrow {
        bottom: 0px !important;
        border-width: 0px !important;
        border-top-color: #FFFFFF !important;
    }
    .myTitle{
        font-size: 18px !important;
        font-weight: 700;
        position: relative;
        z-index: 2;
        color: #333 !important;
        &::before{
            content: '';
            position: absolute;
            width: 50px;
            background: #2196F3;
            height: 6px;
            border-radius: 3px;
            left: 0;
            bottom: 0 !important;
            z-index: -1;
        }
    }
</style>
<style lang="less" scoped>
.nameBox{
    display: flex;
    align-items: center;
    height: 30px;
    .bianji-img{
        width: 20px !important;
        margin-left: 15px;
        height: 20px !important;
    }
}
</style>
